const globalStrings = {
  gamesManagement: "Gestion des Parties",
  createGame: "Créer une Nouvelle Partie",
  gameName: "Nom de la Partie",
  createdAt: "créée le",
  account: "compte",
  accounts: "comptes",
  player: "joueur",
  playerName: "Prénom du Joueur",
  players: "joueurs",
  create: "Créer",
  submit: "Valider",
  startHexploit: "Démarrer l'Hexploit",
  email: "Email",
  success: "Vos personnages ont bien été créés !",
  delete: "Supprimer",
  addCharacter: "Ajouter un personnage",
  characterName: "Nom de son Personnage",
  joinGame: "Rejoindre la partie",
  charactersCreation: "Création de vos personnages",
  goodLuck: "A vos imaginations !",
  accountTitle: "Mon compte",
  accountEmailVerified: "Email vérifié",
  accountEmailValidationRequired: "Validation requise",
  accountEmailNotValidated: "Votre email n'a pas encore été validé",
  accountSendValidationEmail: "Envoyer un email de validation",
  accountGeneralInfo: "Informations générales",
  accountEmailPlaceholder: "email@adresse.com",
  accountNewsletterLabel: "Être abonné à la newsletter",
  accountNewsletterEnableConfirmTitle: "Confirmer l'abonnement",
  accountNewsletterEnableConfirmBody:
    "En continuant, vous acceptez de recevoir des emails d'informations et de nouveautés Hexploit.",
  accountNewsletterDisableConfirmTitle: "Confirmer le désabonnement",
  accountNewsletterDisableConfirmBody: "Êtes-vous sûr de ne plus vouloir être informé des nouveautés ?",
  accountNewsletterConfirmCancel: "Annuler",
  accountNewsletterConfirmConfirm: "Confirmer",
  accountSaveChanges: "Enregistrer les modifications",
  accountSecurityTitle: "Sécurité",
  accountNewPasswordLabel: "Nouveau mot de passe",
  accountNewPasswordPlaceholder: "Nouveau mot de passe...",
  accountPasswordConfirmationLabel: "Confirmation du nouveau mot de passe",
  accountPasswordConfirmationPlaceholder: "Confirmez votre nouveau mot de passe...",
  accountChangePassword: "Changer mon mot de passe",
  accountGamesTitle: "Mes parties",
  accountGamesCount: "parties",
  accountNoGames: "Aucune partie en cours pour le moment.",
  accountViewGame: "Voir la partie",
  accountUpdateSuccess: "Mise à jour des informations confirmée",
  accountPasswordMismatch: "La confirmation du mot de passe ne correspond pas",
  accountWelcomeEmailSubject: "Bienvenue dans Hexploit",
  accountParticipantsLabel: "participants",
  accountCharactersLabel: "personnages",
  accountDeletePrompt: "Si vous ne souhaitez plus être enregistré chez A2Z eSanté, vous pouvez nous demander de",
  accountDeleteLinkText: "supprimer votre compte",
  accountDeleteSuffix: "ainsi que toutes ses données.",
  accountValidationEmailSentTitle: "Email envoyé",
  accountValidationEmailSentBody: "Un email de validation a été envoyé.",
  accountPasswordResetSentTitle: "Email envoyé",
  accountPasswordResetSentBody: "Un email de changement de mot de passe a été envoyé.",
  accountNewsletterSavedTitle: "Préférences enregistrées",
  accountNewsletterSavedBody: "Vos préférences de newsletter ont été mises à jour.",
  accountMetaTitle: "Hexploit - Mon compte",
  gamesAdminDescription: "Créez une nouvelle partie et gérez les sessions en cours.",
  gamesAdminBadge: "Admin",
  gamesInProgressTitle: "Parties créées",
  gamesCountLabel: "parties",
  gamesFilterDateLabel: "Filtrer par date",
  gamesFilterDatePlaceholder: "Choisir une date",
  gameJoinBadge: "Rejoindre la partie",
  gameHeaderLine1: (name: string) => `Partie Hexploit : ${name}`,
  gameHeaderLine2: (date: string, time: string) => `du ${date} à ${time}`,
  gameJoinQrHint: "Scannez ce QR code pour rejoindre la partie.",
  gameOpenLink: "Ouvrir le lien",
  gameShareLink: "Partager le lien",
  gameShareTitle: "Rejoindre Hexploit",
  gameParticipantsTitle: "Participants",
  gameCharactersTitle: "Personnages",
  gameMyCharactersTitle: "Mes personnages",
  gameParticipantNameLabel: "Nom:",
  gameParticipantCharacterLabel: "Perso:",
  gameParticipantEmailLabel: "Email:",
  gameManageParticipant: "Gérer ce participant",
  gameDeleteCharacterTitle: "Supprimer le personnage ?",
  gameDeleteCharacterBody: "Cette action est définitive.",
  gameDeleteCharacterConfirm: "Supprimer",
  gameDeleteCharacterCancel: "Annuler",
  gameDeleteCharacterAria: "Supprimer le personnage",
  gameManageCharacter: "Modifier le personnage",
  joinIntro: "Pour tester Hexploit avant tout le monde, renseigne ton adresse email.",
  joinEmailLabel: "Votre adresse Email",
  joinEmailDescription:
    "En créant votre compte, vous pourrez y retrouver toutes vos parties et les personnages associés",
  joinEmailPlaceholder: "email@example.com",
  joinReadyBadge: "Prêt à jouer",
  joinReadyDescription: "Vous allez rejoindre cette partie et accéder à la création de vos personnages.",
  joinLogoAlt: "Hexploit logo",
  manageIntro: "Ajoutez et personnalisez les personnages de votre camp.",
  manageCharacterLabel: (index: number) => `Personnage ${index}`,
  manageDeleteCharacterAria: "Supprimer ce personnage",
  managePlayerNamePlaceholder: "Le vrai prénom du joueur",
  manageCharacterNamePlaceholder: "Le nom de son personnage, soyez créatifs !",
  manageDescriptionLabel: "Description",
  manageDescriptionPlaceholder: "Décrivez ce personnage",
  manageDictationAria: "Dicter la description",
  manageImageLabel: "Photo de l'ÂmeChimie",
  manageChangeImage: "Changer l'image",
  manageChooseImage: "Choisir une image",
  manageResetImage: "Reset",
  manageNoFileSelected: "Aucun fichier sélectionné",
  manageSoulLabel: "Âme",
  manageAppearanceLabel: "Apparence",
  managePersonalityLabel: "Personnalité",
  managePowersLabel: "Pouvoirs",
  manageWeaknessesLabel: "Faiblesses",
  manageAddCharacterHint: "Appuie pour créer un nouveau personnage",
  manageSubmitCharacters: "Créer les Avatars",
  manageChooseCardLabel: "Choisir une carte",
  manageChooseCardTitle: (label: string) => `Choisir une carte · ${label}`,
  manageSearchCardPlaceholder: "Rechercher une carte",
  manageClearSelection: "Effacer la sélection",
  manageToastAccountCreatedTitle: "Compte créé",
  manageToastAccountCreatedBody: "Votre compte a été créé. Un email de validation a été envoyé.",
  manageToastAccountCreatedBodyShort: "Votre compte vient d'être créé. Un email de validation a été envoyé.",
  manageToastSavedTitle: "Modifications enregistrées",
  manageToastSavedBody: "Vos personnages ont bien été enregistrés.",
  manageToastAutosaveTitle: "Sauvegarde automatique",
  manageToastAutosaveBody: "Modifications enregistrées.",
  manageFeedbackTitle: "Qu'as-tu pensé du jeu ? Donne-nous ton avis, c'est très important pour nous !",
  manageFeedbackCta: "Donner mon avis (2min)",
  manageEmailReminderLine1:
    "Pense à regarder tes e-mails, tu y retrouveras un lien vers ton compte Hexploit pour retrouver la partie que tu viens de faire.",
  manageEmailReminderLine2: "Si le jeu t’a plu, suis-nous sur les réseaux pour ne rien rater !",
  manageInstagramAria: "Hexploit Instagram",
  manageDiscordAria: "Hexploit Discord",
  manageYoutubeAria: "Hexploit Youtube",
  manageLogoAlt: "Hexploit",
  emptyValue: "—",
  resetPasswordTitle: "Hexploit - Nouveau mot de passe",
  resetPasswordHeading: "Réinitialiser le mot de passe",
  resetPasswordPasswordLabel: "Mot de passe",
  resetPasswordPasswordPlaceholder: "Votre mot de passe...",
  resetPasswordPasswordConfirmationLabel: "Confirmation du mot de passe",
  resetPasswordPasswordConfirmationPlaceholder: "Confirmez votre mot de passe...",
  resetPasswordCancel: "Annuler",
  resetPasswordSubmit: "Envoyer",
  resetPasswordInvalidPassword: "Mot de passe invalide",
  resetPasswordInvalidConfirmation: "La confirmation du mot de passe est invalide",
  resetPasswordInvalidLink: "Lien de réinitialisation invalide",
  resetPasswordInvalidEmailOrCode: "Email ou code invalide",
  signupTitle: "Hexploit - Créer un compte",
  signupHeading: "Créer un compte",
  signupEmailLabel: "Email",
  signupEmailPlaceholder: "email@addresse.com",
  signupPasswordLabel: "Mot de passe",
  signupPasswordPlaceholder: "Votre mot de passe...",
  signupPasswordConfirmationPlaceholder: "Confirmez votre mot de passe",
  signupNewsletterLabel: "Je m'abonne à la newsletter pour suivre l'avancement du jeu",
  signupSubmit: "Créer un compte",
  signupHaveAccount: "Vous avez déjà un compte ?",
  signupLoginLink: "Se connecter",
  signupSuccess: "Votre compte a été créé. Vous allez recevoir un email de validation. Pensez à vérifier vos SPAMS.",
  signupPasswordMismatch: "La confirmation du mot de passe ne correspond pas",
  signupGenericError: "Une erreur est survenue. Veuillez réessayer.",
  signupEmailExists: "Un compte existe déjà avec cet email",
  loginTitle: "Hexploit - Connexion",
  loginHeading: "Connexion",
  loginEmailLabel: "Email",
  loginEmailPlaceholder: "email@addresse.com",
  loginPasswordLabel: "Mot de passe",
  loginPasswordPlaceholder: "Votre mot de passe...",
  loginForgotPassword: "Mot de passe oublié",
  loginSubmit: "Se connecter",
  loginNoAccount: "Vous n'êtes pas encore inscrit ?",
  loginCreateAccountLink: "Créer un compte",
  loginInvalidCredentials: "Mauvais email ou mot de passe",
  loginTooManyAttempts: "Trop d'essais en peu de temps, veuillez contacter team@hexploit.fr",
  mailVerificationTitle: "Hexploit - Vérification de l'email",
  navSiteLink: "Hexploit.fr",
  navGames: "Parties",
  navAccount: "Mon compte",
  navLanguage: "Langue",
  footerTagline: "Hexploit - et si créer des histoires devenait un jeu ?",
  footerVideoRules: "Règles en vidéo",
  footerContact: "Nous contacter",
  footerInstagramAria: "Rejoins nous sur instagram",
  footerYoutubeAria: "Chaine Youtube d'Hexploit",
  footerFacebookAria: "Rejoins nous sur facebook",
};

export default globalStrings;
